import ReactDom from "react-dom";
import NarrativeSubmenu from "./NarrativeSubmenu.jsx";

export default function renderNarrativeSubmenu(store) {
  document.querySelectorAll(".js-narrative-submenu-mount").forEach((mount) => {
    const navItems = JSON.parse(mount.getAttribute("data-nav-items"));
    const contentsHeader = JSON.parse(
      mount.getAttribute("data-contents-header"),
    );
    const narrativeTitle = mount.getAttribute("data-narrative-title");

    const sectionTitle = mount.getAttribute("data-section-title");

    const pageInfo = JSON.parse(mount.getAttribute("data-page-info"));

    const toolbarDictionary = JSON.parse(
      mount.getAttribute("data-toolbar-dictionary"),
    );

    const toolbarOptions = JSON.parse(
      mount.getAttribute("data-toolbar-options"),
    );

    const toolbarPdf = JSON.parse(
      mount.getAttribute("data-toolbar-pdf") || "{}",
    );

    ReactDom.render(
      <NarrativeSubmenu
        contentsHeader={contentsHeader}
        narrativeTitle={narrativeTitle}
        sectionTitle={sectionTitle}
        navItems={navItems}
        pageInfo={pageInfo}
        toolbarDictionary={toolbarDictionary || undefined}
        toolbarOptions={toolbarOptions}
        toolbarPdf={toolbarPdf}
        setDraftReport={(draftReport) =>
          store.setState({ draftReport: draftReport })
        }
      />,
      mount,
    );
  });
}
